import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import AuthorityList from '../../components/Authority/AuthorityList';

const AuthorityListPage = () => {
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    };

    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className="row" style={{ padding: '10px 16px' }}>
                <div className="col-md-6">
                    <h4 style={{ color: '#28326f', margin: 0 }}>Authorities</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Authorities" />
                </div>
                <div className="col-md-6">
                    {authData.user.user_type === 'l1' && (
                        <div className="d-flex gap-2" style={{ width: 'auto', float: 'right' }}>
                            <Link to="/add-authority">
                                <button type="button" className="submit_button">
                                    Add Authority
                                </button>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
            <div className="scheme p-3">
                <AuthorityList />
            </div>
        </div>
    );
};

export default AuthorityListPage;
